import { DangerZoneRow } from '../../primitives';
import type { WorkshopSales } from '../use-workshop-sales';

/** The danger-zone row for a disabled workshop: puts it back on sale. */
export function ReEnableWorkshopRow({ sales }: { sales: WorkshopSales }) {
  return (
    <DangerZoneRow
      title="Workshop disabled"
      warn={Boolean(sales.errorMessage)}
      note={
        sales.errorMessage ? (
          <span role="alert">{sales.errorMessage}</span>
        ) : (
          'New bookings are stopped. Re-enable it to put the workshop back on sale.'
        )
      }
    >
      <button
        type="button"
        className="nb-btn"
        disabled={sales.isPending}
        onClick={() => void sales.run('enable')}
        style={{ whiteSpace: 'nowrap' }}
      >
        {sales.isPending ? 'Re-enabling…' : 'Re-enable workshop'}
      </button>
    </DangerZoneRow>
  );
}
